import { voiceCallService, clientsCentralSearchServiceV2 } from 'config/api';
import actionTypes from './actionTypes';

export const getCapabilityToken = () => async (dispatch) => {
  dispatch({ type: actionTypes.DO_VOICE_CALL });

  try {
    const res = await voiceCallService.get('');

    dispatch({
      type: actionTypes.DO_VOICE_CALL_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: actionTypes.DO_VOICE_CALL_ERROR,
      payload: error,
    });
  }
};

export const setVoiceCallData = (data, phoneNumberToSearch, singleNumberDial) => async (dispatch) => {
  const payload = { ...data };

  if (phoneNumberToSearch) {
    dispatch({ type: actionTypes.VOICE_CALL_CLIENT_DATA_LOADING });
    const params = { q: phoneNumberToSearch, includeClientList: true, field: 'phone' };
    const {
      data: {
        data: { customers, total },
      },
    } = await clientsCentralSearchServiceV2.get('/customers', { params });
    if (total === 1) {
      const client = customers[0];
      payload.firstName = client.firstName;
      payload.lastName = client.lastName;
      payload.cmdUri = client.profileId;
    }
    if (singleNumberDial && !payload.firstName) {
      payload.firstName = data.fullName;
    }
  }

  dispatch({
    type: actionTypes.SET_VOICE_CALL_DATA,
    payload,
  });
};

export const setCallStatus = (payload) => ({
  type: actionTypes.SET_CALL_STATUS,
  payload,
});

export const setCallMinimize = (payload) => ({
  type: actionTypes.SET_CALL_MINIMIZE,
  payload,
});

export const setCallInProgress = (payload) => ({
  type: actionTypes.SET_CALL_IN_PROGRESS,
  payload,
});
